import React, { useState } from "react";
import Footer from "../../common/Footer";
import Nav from "../../common/Nav";

const UpdateDocument = () => {
  const [documents, setDocuments] = useState([
    { id: 1, name: "Passport.pdf", uploadedOn: "2023-10-01" },
    { id: 2, name: "Visa.pdf", uploadedOn: "2023-10-05" },
  ]);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  const handleUpload = () => {
    if (selectedFile) {
      const newDocument = {
        id: documents.length + 1,
        name: selectedFile.name,
        uploadedOn: new Date().toISOString().split("T")[0],
      };
      setDocuments([...documents, newDocument]);
      setSelectedFile(null);
      alert("Document uploaded successfully!");
    } else {
      alert("Please select a file to upload.");
    }
  };

  const handleDelete = (id) => {
    setDocuments(documents.filter((doc) => doc.id !== id));
    alert("Document deleted successfully!");
  };

  return (
    <div>
        <div className="p-6">
            <Nav/>
        </div>
    <div className="min-h-screen bg-gray-100 mt-12 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8">Update Documents</h1>

        {/* Upload Document Section */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Upload New Document</h2>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <input
              type="file"
              accept="application/pdf"
              onChange={handleFileChange}
              className="border border-gray-300 rounded-md p-2 flex-grow"
            />
            <button
              onClick={handleUpload}
              className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 transition duration-300"
            >
              Upload
            </button>
          </div>
        </div>

        {/* List of Documents */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">Uploaded Documents</h2>
          {documents.length > 0 ? (
            <div className="space-y-4">
              {documents.map((doc) => (
                <div
                  key={doc.id}
                  className="flex flex-col sm:flex-row justify-between items-center border-b border-gray-200 pb-4"
                >
                  <div className="flex-1">
                    <p className="font-medium">{doc.name}</p>
                    <p className="text-sm text-gray-500">
                      Uploaded on: {doc.uploadedOn}
                    </p>
                  </div>
                  <button
                    onClick={() => handleDelete(doc.id)}
                    className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition duration-300 mt-2 sm:mt-0"
                  >
                    Delete
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500">No documents uploaded yet.</p>
          )}
        </div>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default UpdateDocument;